export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">
                白云视频
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              白云视频是一个提供西瓜视频免费和西瓜视频同类型高清在线观看体验的平台，免费看电影电视剧，高清不卡顿，让您畅享免费影视的乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="#features" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">平台特色</a>
              <a href="#media" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">精彩视频</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">热播榜单</a>
              <a href="#index" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">分类索引</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              帮助中心
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="#faq" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
              <a href="#contact" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
              <a href="#about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
              <a href="#updates" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">最新动态</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-500 leading-relaxed">
              诚邀优质内容方与品牌方加入，共建高清免费影视生态。
            </p>
            <a
              href="#contact"
              className="inline-block mt-3 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              成为合作伙伴 <i className="ri-arrow-right-line ml-1 text-xs"></i>
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 白云视频 版权所有 | 免费影视不卡顿
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">关注我们</span>
            <a href="#" className="w-7 h-7 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-background-100 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-7 h-7 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-background-100 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-7 h-7 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-background-100 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
              <i className="ri-bilibili-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}